export class StrokeData {
  private start: Coord;
  private end: Coord;

  constructor(start: Coord, end: Coord) {
    this.start = start;
    this.end = end;
  }

  get Start() {
    return this.start;
  }
  get End() {
    return this.end;
  }
}

export class Coord {
  constructor(private x: number, private y: number) {}

  get X() {
    return this.x;
  }
  get Y() {
    return this.y;
  }
}
